import HeaderBreadCrumb from './HeaderBreadCrumb';

export default HeaderBreadCrumb;
